/** @jsx jsx */
import React, { useEffect, useCallback, useMemo } from 'react';
import { jsx, css } from '@emotion/react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ReviewInvoiceList from './ReviewInvoiceList';
import { getReviewLocationList } from '../../actions/dispatchAction/reviewInboxAction';
import { getAccessLevelsByModuleName } from '../../util/customMethods';

/**
 * Inbox (v2)
 *
 * Changes:
 *  - Functional component (no componentWillMount)
 *  - reviewPermission via useMemo (was module-level let — race condition)
 *  - Emotion styling
 */

const PAGE_TITLE = 'Review Inbox';

const pageHeader = css`
    margin-bottom: 12px;
    h4 { font-size: 1.15rem; font-weight: 600; color: #2c3e50;
         display: flex; align-items: center; gap: 8px; margin: 0;
         i { color: #5a8bb5; } }
`;

const Inbox = ({ dispatch, reviewInvoice }) => {
    useEffect(() => {
        document.title = PAGE_TITLE;
        dispatch(getReviewLocationList(null, true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const reviewPermission = useMemo(() => {
        const perms = getAccessLevelsByModuleName('Review Invoice');
        return (perms[0] && perms[0].basicAccess) || {};
    }, []);

    const handleLocationChange = useCallback((value) => {
        dispatch(getReviewLocationList(value, true));
    }, [dispatch]);

    return (
        <>
            <div className="page-header" css={pageHeader}>
                <div className="row mb-10">
                    <div className="col-md-12 col-sm-12">
                        <h4><i className="fa fa-envelope-o" /> Inbox</h4>
                    </div>
                </div>
            </div>
            <div className="pd-10 bg-white border-radius-4 box-shadow container-box">
                <ReviewInvoiceList
                    reviewInvoice={reviewInvoice}
                    reviewPermission={reviewPermission}
                    onInvoiceInfoFieldsChange={handleLocationChange}
                />
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    refNotify: state.refNotify,
    authInfo: state.authInfo,
    reviewInvoice: state.reviewInbox.reviewInvoiceList,
});

export default withRouter(connect(mapStateToProps)(Inbox));
